var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseStudyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75H13.7402V12.25H10V13.75ZM10 10.75H17.4808V9.25H10V10.75ZM10 7.75H17.4808V6.25H10V7.75ZM8.05775 17.5C7.55258 17.5 7.125 17.325 6.775 16.975C6.425 16.625 6.25 16.1974 6.25 15.6923V4.30775C6.25 3.80258 6.425 3.375 6.775 3.025C7.125 2.675 7.55258 2.5 8.05775 2.5H19.4423C19.9474 2.5 20.375 2.675 20.725 3.025C21.075 3.375 21.25 3.80258 21.25 4.30775V15.6923C21.25 16.1974 21.075 16.625 20.725 16.975C20.375 17.325 19.9474 17.5 19.4423 17.5H8.05775ZM4.55775 21C4.05258 21 3.625 20.825 3.275 20.475C2.925 20.125 2.75 19.6974 2.75 19.1923V6.30775H4.25V19.1923C4.25 19.2693 4.28208 19.3398 4.34625 19.4038C4.41025 19.4679 4.48075 19.5 4.55775 19.5H17.4423V21H4.55775Z",
    fill: "#4D4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudyIcon);
export default __webpack_public_path__ + "static/media/case-study-icon.b91571add811dd27335f0debe910e20d.svg";
export { ForwardRef as ReactComponent };